var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDataAnalysisIcon = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.66667 0C9.39052 0 9.16667 0.223858 9.16667 0.5V12.3327H8.16667V5.83333C8.16667 5.55719 7.94281 5.33333 7.66667 5.33333H5.66667C5.39052 5.33333 5.16667 5.55719 5.16667 5.83333V12.3327H4.166V3.16667C4.166 2.89052 3.94214 2.66667 3.666 2.66667H1.666C1.38986 2.66667 1.166 2.89052 1.166 3.16667V12.3327H0V13.3333H13.3333V12.3327H12.1667V0.5C12.1667 0.223858 11.9428 0 11.6667 0H9.66667ZM10.166 12.3327H11.166V0.999333H10.166V12.3327ZM2.16667 12.3333H3.16667V3.66667H2.16667V12.3333ZM6.16667 12.3327H7.166V6.33267H6.16667V12.3327Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDataAnalysisIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/DataAnalysisIcon.c7fcb0440217840d77834caa236338ce.svg";